import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../../../lib/store';
import { useRescueContext } from '../../lib/RescueContext';
import { logout } from '../../../lib/authentication';
import { clearImportJobKey } from '../../lib/importJobCookie';
import styles from './Header.module.scss';

export default function Header() {
  const location = useLocation();
  const session = useSelector((state: AppState) => state.session);
  const { orgName, setSidebarOpen } = useRescueContext();

  const path = location.pathname.replace(/\/$/, '') || '/rescue';

  const handleLogout = async () => {
    // Drop the saved CSV-import resume pointer so the next user on a shared
    // browser doesn't inherit it (and hit a Forbidden when resuming).
    clearImportJobKey();
    try {
      await logout();
    } catch {
      // Redirect handled by logout
    }
  };

  return (
    <div className={styles.headerWrapper}>
      <header className={styles.header}>
        <div className={styles.left}>
          <button className={styles.mobileMenuBtn} onClick={() => setSidebarOpen(true)} aria-label="Toggle menu">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>

        <div className={styles.actions}>
          <span className={styles.orgName}>{orgName}</span>
          <button className={styles.logoutBtn} onClick={handleLogout}>
            Log Out
          </button>
        </div>
      </header>
      {session?.impersonating && (
        <div className={styles.impersonationBanner}>You are impersonating {session.email}</div>
      )}
    </div>
  );
}
